module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="task-panel">\n    <div class="taskHeader" style="display: none;"></div>\n    <div class="taskBody">\n        <div class="sideOptions closedOptions"></div>\n        <div class="entryContainer"></div>   \n        <div class="calendarTabBar"></div>\n        <div class="calendar">\n            <div class="calendarBanner">\n                <div class="title">\n                    Calendar\n                </div>\n            </div>    \n            <div class="calendarDisplay"></div>\n        </div>\n    </div>\n</div>';

}
return __p
}